import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiFileText } from 'react-icons/fi';
import styles from './WidgetNoData.module.scss';

type Props = {
	message?: string;
	className?: string;
};

const WidgetNoData = ({ message, className }: Props) => {
	const { t } = useTranslation();
	const text = message ?? (t('dashboard.no_data_alternative' as any) as string);

	return (
		<div className={`${styles.container} ${className || ''}`.trim()}>
			<div className={styles.iconWrapper}>
				<FiFileText />
			</div>
			<div className={styles.message}>{text}</div>
		</div>
	);
};

export default WidgetNoData;
